import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

export interface ChatMessage {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

@Injectable({
  providedIn: 'root'
})
export class RcmChatService {
  private base = '/api';

  constructor(private http: HttpClient) { }

  send(messages: ChatMessage[]) {
    return this.http.post<{ text: string }>(`${this.base}/rcm-chat`, { messages });
  }
}
